import { ProjectDataflowModel } from '../../../services/ProjectService';
import { Trans } from 'react-i18next';
import { LogsComponent } from './LogsComponent';
import { StepsComponent } from './StepsComponent';
import { Link } from 'react-router-dom';

interface ImportSectionProps {
  importData: ProjectDataflowModel | undefined;
  showHistoryButton?: boolean;
  fromList?: boolean;
}

export function ImportSection({ importData, showHistoryButton = true, fromList = false}: ImportSectionProps) {

  return (
    <>
      <div className="border rounded tile-content p-3 m-4 d-flex flex-column gap-2">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="title">
            {fromList ? (<Trans>configuration.projects.dataImport</Trans>) : (<Trans>configuration.projects.lastDataImport</Trans>)}
          </h5>
          {showHistoryButton && ( 
              <Link to="/project/projectImportHistory" className="btn btn-primary" ><Trans>configuration.projects.processHistory</Trans></Link>        
          )}
        </div>

        {importData  && importData.Details && importData.Details.length > 0 ? (
          <>
            <p>
              <strong><Trans>general.status</Trans>:</strong> {importData.Status && <Trans>{`general.${importData.Status}`}</Trans>}
            </p>
            <StepsComponent details={importData.Details || []} />
              {(importData.Details || []).some(detail => detail.Logs && detail.Logs.length > 0) && (
            <LogsComponent logs={(importData.Details || []).flatMap(detail => detail.Logs || [])} />
          )}
          </>
        ) : (
          <p><Trans>configuration.projects.noImportDataAvailable</Trans></p>
        )}
      </div>
    </>
    
  );
}
